var $487730a9a03f7789$exports = {};
$487730a9a03f7789$exports = {
    "info": `Informacije`,
    "negative": `Napaka`,
    "positive": `Uspe\u{161}no`
};


export {$487730a9a03f7789$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
